import React from 'react';
import Wallet from '../Wallet';
import emptyCpayImage from '../../../../img/cpay-svg/empty.svg';
import emptyNFGImage from '../../../../img/nfgpay-svg/empty-nfg.svg';
import emptyFinvaroImage from '../../../../img/finvaro/empty-finvaro.svg';
import emptyClarniumImage from '../../../../img/clarnium/empty-clarnium.svg';
import emptyInexImage from '../../../../img/inex/empty-inex.svg';
import emptyInstaImage from '../../../../img/instaXchange/empty-insta.svg';
import emptyCoineraImage from '../../../../img/coinera/empty-coinera.svg';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import './style.scss';
import { identity } from '../../../../utils/getIdentity';
import Button from "../../../../components/Button";

const emptyImage = {
  cpay: emptyCpayImage,
  nfg: emptyNFGImage,
  finvaro: emptyFinvaroImage,
  clarnium: emptyClarniumImage,
  inex: emptyInexImage,
  insta: emptyInstaImage,
  coinera: emptyCoineraImage
}


const WalletsList = ({ withdrawWallets, walletsFetching, selectedWallet, setSelectedWallet, setFrom, permissions, page, pages, getAdminWallets }) => {
  return (
    <div className="fee-wallets-list">
      {!walletsFetching ? (
        <div className="fee-wallets-list__list">
          {withdrawWallets.length ? (
            <>
              {withdrawWallets.map((wallet, index) => {
                return (
                  <Wallet
                    key={index}
                    wallet={wallet}
                    selectedWallet={selectedWallet}
                    setSelectedWallet={setSelectedWallet}
                    setFrom={setFrom}
                    permissions={permissions}
                  />
                );
              })}
              {+page < +pages && (
                <Button onClick={() => getAdminWallets(+page + 1)} type="primary">Load more</Button>
              )}
            </>
          ) : (
            <div className="fee-wallets-list__empty">
              <span className="transactions-list__empty-title">All available wallets will show up here.</span>
              <img src={emptyImage[identity]} className="transactions-list__empty-image" alt="empty" />
            </div>
          )}
          {/* {selectedWallet && (
            <button
              type="button"
              className={`fee-wallets-list__select fee-wallets-list__select-${identity}`}
              disabled={!selectedWallet}
              onClick={() => {
                setFrom(selectedWallet.address);
              }}
            >
              Send
            </button>
          )} */}
        </div>
      ) : (
        <div className="fee-wallets-list__loader">
          <Spin indicator={<LoadingOutlined className={`spin-${identity}`} style={{ fontSize: 24 }} spin />} />
        </div>
      )}
    </div>
  );
};

export default WalletsList;
